var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H14V9H1V12H2C2 12.7956 2.31607 13.5587 2.87868 14.1213C3.44129 14.6839 4.20435 15 5 15C5.79565 15 6.55871 14.6839 7.12132 14.1213C7.68393 13.5587 8 12.7956 8 12H14C14 12.7956 14.3161 13.5587 14.8787 14.1213C15.4413 14.6839 16.2044 15 17 15C17.7956 15 18.5587 14.6839 19.1213 14.1213C19.6839 13.5587 20 12.7956 20 12H22V7L19 3ZM5 13.5C4.60218 13.5 4.22064 13.342 3.93934 13.0607C3.65804 12.7794 3.5 12.3978 3.5 12C3.5 11.6022 3.65804 11.2206 3.93934 10.9393C4.22064 10.658 4.60218 10.5 5 10.5C5.39782 10.5 5.77936 10.658 6.06066 10.9393C6.34196 11.2206 6.5 11.6022 6.5 12C6.5 12.3978 6.34196 12.7794 6.06066 13.0607C5.77936 13.342 5.39782 13.5 5 13.5ZM17 13.5C16.6022 13.5 16.2206 13.342 15.9393 13.0607C15.658 12.7794 15.5 12.3978 15.5 12C15.5 11.6022 15.658 11.2206 15.9393 10.9393C16.2206 10.658 16.6022 10.5 17 10.5C17.3978 10.5 17.7794 10.658 18.0607 10.9393C18.342 11.2206 18.5 11.6022 18.5 12C18.5 12.3978 18.342 12.7794 18.0607 13.0607C17.7794 13.342 17.3978 13.5 17 13.5ZM16 7V4.5H18.5L20.46 7H16ZM17 2H13V8H2L0.57 3H0V1H12L13 0H17V2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.689d352d79cfd3707b79642eccc93b0a.svg";
export { ForwardRef as ReactComponent };